import React, { Component } from "react";
import { connect } from "react-redux";

import Plot from "../plot";
import PlotLegend from "../../components/plot-legend";


import Styles from "./plot-container.module.scss";
import { selectCurrentTimestamp } from "../../ducks/time";

class PlotContainer extends Component {
    renderPlotHeader() {
        const { video, dataScale, colors } = this.props;
        return (
            <div className={Styles.plotHeader}>
                <div className={Styles.detailHeader}>
                    <div className={Styles.detailHeaderItem} data-fill={true}>
                        Objects
                    </div>
                    <div className={Styles.detailHeaderItem}>
                        Visible
                    </div>
                    <div className={Styles.detailHeaderItem}>
                        Tally
                    </div>
                </div>
                <PlotLegend video={video} dataScale={dataScale} colors={colors} />
            </div>
        )
    }

    renderPlots() {
        const { processed } = this.props.video;
        const { timeScale, dataScale, datumWidth, colors, currentTimestamp } = this.props;
        const plots = processed.plots.map((plot, index) => {
            return <Plot
                key={plot.plotKey}
                color={colors[index]}
                timeScale={timeScale}
                dataScale={dataScale}
                datumWidth={datumWidth}
                currentTimestamp={currentTimestamp}
                {...plot}
            />
        });
        return <div className={Styles.plots}>{plots}</div>;
    }
   
    render() {
        return (
            <div className={Styles.plotContainer}>
                {this.renderPlotHeader()}
                <div className={Styles.containerContent}>
                    {this.renderPlots()}
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        currentTimestamp: selectCurrentTimestamp(state, props.video),
    };
};
const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlotContainer);



// WEBPACK FOOTER //
// ./src/components/plot-container/plot-container.js